import SignupPage from '@/pages/Signup';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.Signup = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const root = createRoot(document.getElementById(this.id));

        root.render(<SignupPage/>);
    }
});
